// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b2d9258f","45":"b03e64dd","124":"09ce4e4a","356":"51035c26","378":"3163666b","428":"0924c238","488":"c3a7d076","613":"f019915e","663":"08837f26","957":"0998146c"}[chunkId] + ".chunk.js";
};